import React, { useEffect } from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import useReduxState from 'src/hooks/useReduxState';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __set, __remove } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import { useOrderStore } from 'src/hooks/order';

let c = System.getParams();

const OrderDetailListingHeader = () => {
    const { OrderDetailTabList, currencyType: { USD } } = Constants
    const [isReorderable, setIsReOrderable] = useReduxState(false, 'setIsReOrderable')
    const [isCancellable, setIsCancellable] = useReduxState(false, 'setIsCancellable')
    const [{ }, { check_item_exists_in_cart }, { add_cart_in_Bulk }] = useCartStore();
    const [{ selected_fields }, { }, { remove_all_selected_fields }] = useOrderStore();
    const [__check] = useAxiosIndicatorCheck();

    const onReOrderablePart = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            order_number: c.order_number,
            tab: System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value,
            orderFilter: 'reorder'
        });
        history.pushState('', '', url);
        await setIsReOrderable(true)
        await setIsCancellable(false)
        await remove_all_selected_fields()
    }

    const onCancellable = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            order_number: c.order_number,
            tab: System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value,
            orderFilter: 'cancel'
        });
        history.pushState('', '', url);
        await setIsCancellable(true)
        await setIsReOrderable(false)
        await remove_all_selected_fields()
    }

    const onAlllink = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            order_number: c.order_number,
            tab: System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value,
            orderFilter: 'all'
        });
        history.pushState('', '', url);
        await setIsReOrderable(false)
        await setIsCancellable(false)
        await remove_all_selected_fields()
    }

    useEffect(() => {
        if (c.orderFilter && c.orderFilter.toLowerCase() === 'reorder') {
            setIsReOrderable(true)
            setIsCancellable(false)
        } else if (c.orderFilter && c.orderFilter.toLowerCase() === 'cancel') {
            setIsCancellable(true)
            setIsReOrderable(false)
        }
    }, []);

    const AddToCart = async () => {
        let cartData = Object.values(selected_fields)
        let cart= []

        let checkItemParam = []
        let checkExistingItemResponse = false

        cartData.filter(obj => {
            let items = {}
            if (obj?.customerPartNumber !== null) {
                items = { itemNumber: obj?.orderItemNumber, cpn: obj?.customerPartNumber }
                checkItemParam.push(items)
            }
        })

        if (checkItemParam?.length > 0) {
            __set('CART_API_CALL');
            checkExistingItemResponse = await check_item_exists_in_cart({ items: checkItemParam })
            __remove('CART_API_CALL');
        }
        
        if (checkExistingItemResponse === true) {
            let productParam = []
            cartData.map(async (v) => {
                productParam.push({
                    "quantity": v.orderQuantity || v.quantity,
                    "currency": USD,
                    "backOrderedQuantity": 0,
                    "cpn": v.customerPartNumber,
                    "VendorCode": v.vendorCode,
                    "SAPMatGroup": v.sAPMatGroup,
                    "partNumber": v.eRPPartNumber,
                    "ItemNumber": v.orderItemNumber,
                    "ManufacturerPartNumber": v.manufacturerPartNumber,
                    "ManufacturerCode": v.manufacturerCode,
                    "ManufacturerName": v.manufacturerName,
                    "AssetURL": v.assetURL,
                    "type": "Shopping",
                    "ERPMFRPartNumber": v.eRPMFRPartNumber,
                    "ERPManufacturerName": v.eRPManufacturerName,
                    "ERPManufacturerCode": v.eRPManufacturerCode,
                    "ShortDescription": v?.shortDescription || '',
                    "isSoftwareDownloadable": v?.SoftwareDownloadFlag === 'Yes' || v?.SoftwareDownloadFlag === true || v?.SoftwareDownloadFlag === 'Y' ? true : false,
                    "mdmMaterialId": v?.mdmMaterialID,
                    "seoerpmfrPartNumber": v?.SEOERPMFRPartNumber,
                    "seoManufacturerName" : v?.SEOManufacturerName,

                })
            })

            System.popup('BomToCartItemReplacePopup', {
                cartReplaceItem: { "cartItems": productParam }, isFrom: 'order'
            })
        } else {
            cartData.map(async (v) => {
                const newObj = {
                    partNumber: v.eRPPartNumber,
                    ItemNumber: v.orderItemNumber,
                    ManufacturerPartNumber: v.manufacturerPartNumber,
                    ERPMFRPartNumber: v.eRPMFRPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    quantity: v.orderQuantity || v.quantity,
                    backOrderedQuantity: 0,
                    manufacturerName: v.manufacturerName,
                    cpn: v.customerPartNumber,
                    currency: USD,
                    AssetURL: v.assetURL,
                    erpManufacturerName: v.eRPManufacturerName,
                    erpManufacturerCode: v.eRPManufacturerCode,
                    type: "Shopping",
                    ShortDescription: v?.shortDescription || '',
                    isSoftwareDownloadable: v?.SoftwareDownloadFlag === 'Yes' || v?.SoftwareDownloadFlag === true || v?.SoftwareDownloadFlag === 'Y' ? true : false,
                    mdmMaterialId: v?.mdmMaterialID,
                };

                cart.push(newObj)
            })

            let params = {
                currency: USD,
                cartItems: cart
            };
            let selectedProductData = await add_cart_in_Bulk(params);

            System.popup('AddedToCartBomPopup', { cartData: selectedProductData });
        }
    }

    const Cancellation = async () => {
        System.popup("OrderHistoryCancellationPopup", { selected_fields: selected_fields })
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between pt-0 flex-wrap flex-sm-nowrap">
                <div className="font-24 my-0 mb-3 mb-sm-0 font-bold">Orders</div>

                <div className="ms-sm-auto mb-0">
                    <div className="d-flex align-items-center font-12">
                        <b className='me-2'>View: </b>
                        <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 seprate-by-pipe font-12 lh-normal mt-0">
                            <li className="ms-2"
                                onClick={() => onAlllink()}><a href={void (0)}
                                    className={isReorderable === true || isCancellable === true ? 'text-blue2' : 'text-black cursor-default'}> All </a></li>
                            <li className="ms-2"
                                onClick={() => onReOrderablePart()}><a href={void (0)}
                                    className={isReorderable === true ? 'text-black cursor-default' : 'text-blue2'}> Reorderable Parts</a></li>
                            <li className="ms-2"
                                onClick={() => onCancellable()}><a
                                className={isCancellable === true ? 'text-black cursor-default' : 'text-blue2'}> Cancellation Request</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="pcn-line-divider" />
            <div className='tab-right-area'>
                {
                    isReorderable === true &&
                    <button 
                        className={`bs5 btn btn-primary w170 mb-3 mb-md-0 ${__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status && 'disabled'}`}
                        disabled={selected_fields && Object.entries(selected_fields).length > 0 ? false : true}
                        onClick={(e) => {
                            __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : AddToCart()
                        }}
                        >
                            {__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? 
                                <i className="fa fa-spinner fa-spin" /> : 
                                <span>add to cart <i className="fa fa-cart-plus ms-1" /></span>}
                    </button>
                }
                {
                    isCancellable === true &&
                    <button className="bs5 btn btn-secondary w170 mb-3 mb-md-0"
                        disabled={selected_fields && Object.entries(selected_fields).length > 0 ? false : true}
                        onClick={(e) => {
                            __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : Cancellation()
                        }}
                    >Cancel</button>
                }
            </div>
        </>
    )
}

export default OrderDetailListingHeader